var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7215 16.7782C17.6323 16.6792 17.246 16.2433 17.1568 16.1443C16.7903 15.7579 16.7705 15.7282 16.3544 15.3221C15.8294 14.807 15.0369 14.698 14.4327 15.114L13.7095 15.6093C13.4223 15.8075 13.0359 15.7976 12.7685 15.5796C11.7481 14.7475 10.8566 13.7272 10.0542 12.3503C9.26173 10.9733 8.82586 9.68554 8.60793 8.38785C8.54849 8.04114 8.73671 7.70434 9.0537 7.55575L9.84618 7.17932C10.3811 6.92176 10.7179 6.35712 10.6882 5.76276C10.6684 5.41605 10.4802 4.81178 10.3811 4.48488C10.2523 4.06883 10.2028 3.92024 10.0542 3.48437C9.81646 2.81077 9.18248 2.365 8.46924 2.43434C7.87488 2.49377 7.54799 2.5334 6.99325 2.64236C6.59701 2.72161 6.12152 2.83058 5.78471 3.17729C4.00163 5.01981 4.46721 9.63601 7.03287 14.0838C9.58862 18.5118 13.3331 21.226 15.8195 20.6317C16.1662 20.5524 16.4733 20.3444 16.711 20.0869C16.9884 19.7798 17.1667 19.5816 17.4243 19.2548C17.6521 18.9675 17.9592 18.5514 18.0583 18.1849C18.1375 17.8778 18.1276 17.5509 18.0087 17.2537C17.9394 17.0754 17.8304 16.9169 17.7016 16.7782H17.7215Z",
    fill: "#3284FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICall);
export default __webpack_public_path__ + "static/media/i_call.83cf771d7fe9a863d8c555a7f16ddbc8.svg";
export { ForwardRef as ReactComponent };